define(function (require, exports, module) {
    'use strict';

    var config = require('Cloud/config');
    var escapeForHtml = require('lib/escapeForHtml');
    var UploadFail = require('./UploadFail');

    var INVALID_CHARACTERS = config.get('ITEM_NAME_INVALID_CHARACTERS');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function InvalidCharactesFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    Object.assign(InvalidCharactesFail, {
        INVALID_CHARACTERS: INVALID_CHARACTERS,
        WEB_BACKEND_ERROR: 'invalid',
    });

    InvalidCharactesFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: InvalidCharactesFail,
        className: 'InvalidCharactesFail',
        radarName: 'fail_{SOURCE}_invalid-characters',
        message: [
            'Недопустимое имя файла или папки.',
            'В названии нельзя использовать символы <kbd>' + escapeForHtml(INVALID_CHARACTERS) + '</kbd>.',
            'Также название не может состоять только из точки или из двух точек.',
            '<a href="https://help.mail.ru/cloud_web/confines" rel="noopener" target="_blank">Подробнее</a>',
        ].join(' '),
    });

    module.exports = InvalidCharactesFail;
});
